const updateWidget = () => {

  const step1WidgetId = '234245';
  const product1id = '15352455463299';
  const product2id = '1996673712217';
  const product1WidgetSelector = '.product-id-' + product1id;
  const product2WidgetSelector = '.product-id-' + product2id;
  const widgetEl = document.getElementById(`rebuy-widget-${step1WidgetId}`);
  var cartTotal = Rebuy.Cart.cart.total_price;
  const priceThresholdToShow = 4999;

  if(widgetEl !== null) {

    // get gift items from cart that were added by this widget
    const step1Items = Rebuy.Cart.cart.items.filter(item => item.properties?._widget_id == step1WidgetId);
    
    // check if each specific product is in the cart
    const product1InCart = step1Items.some(item => item.product_id == product1id);
    const product2InCart = step1Items.some(item => item.product_id == product2id);
    
    // calculate total cost of gift items
    const step1ItemsInCartCost = step1Items.reduce((acc, item) => acc + item.line_price, 0);
    const cartTotalMinusStepItemsInCartCost = cartTotal - step1ItemsInCartCost;
    
    // console.log("Lewis - Product 1 in cart:", product1InCart);
    // console.log("Lewis - Product 2 in cart:", product2InCart);
    // console.log("Lewis - Step1 Items:", step1Items.map(item => ({product_id: item.product_id, quantity: item.quantity})));
    // console.log("Lewis - Free Gift Items Cost:", step1ItemsInCartCost);
    // console.log("Lewis - Cart Total Minus Free Gifts:", cartTotalMinusStepItemsInCartCost);

    // hide individual products if they're already in cart
    const product1El = widgetEl.querySelector(product1WidgetSelector);
    const product2El = widgetEl.querySelector(product2WidgetSelector);
    
    // console.log("Lewis - Product1 element found:", !!product1El);
    // console.log("Lewis - Product2 element found:", !!product2El);
    
    if (product1El) {
      const newDisplay = product1InCart ? 'none' : 'flex';
      product1El.style.display = newDisplay;
    }
    
    if (product2El) {
      const newDisplay = product2InCart ? 'none' : 'flex';
      product2El.style.display = newDisplay;
    }

    // show/hide entire widget based on cart total and if both products are already added
    const bothProductsInCart = product1InCart && product2InCart;
    const shouldShowWidget = !bothProductsInCart && cartTotalMinusStepItemsInCartCost > priceThresholdToShow;
    
    if (shouldShowWidget) {
      document.querySelector("#rebuy-widget-" + step1WidgetId).style.display = "block";
    } else {
      document.querySelector("#rebuy-widget-" + step1WidgetId).style.display = "none";
      window.dispatchEvent(new Event('resize'));
    }
  }

};

// Combined event listener for all rebuy cart events
const rebuyCartEvents = ['rebuy:cart.change', 'rebuy:cart.ready'];

rebuyCartEvents.forEach(eventType => {
  document.addEventListener(eventType, (event) => {
    updateWidget();
  });
});